<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Procuradores</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[{
                            text: 'Homepage',
                            disabled: false,
                            to: '/home',
                            exact: true,
                        },
                        {
                            text: 'Procuradores',
                            disabled: true,
                            exact: true,
                        },
                        ]"></v-breadcrumbs>
                    </div>
                        <div class="button-group" style="padding-right: 16px;">
                            <v-btn
                                v-if="$check(user, ['lawyers.update.association'])"
                                type="button"
                                color="primary"
                                outlined
                                elevation="0"
                                class="mr-2"
                                @click="openProcurationValidationModal"
                            >
                                Validar procuração
                            </v-btn>
                            <v-btn v-if="$check(user, ['lawyers.create'])" id="btnNew" type="button" color="primary"
                                elevation="0" to="/procuradores/novo">Incluir</v-btn>
                        </div>
                </div>
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense label="Nome" v-model="dataList.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense label="E-mail" v-model="dataList.filter.email" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense label="OAB" v-model="dataList.filter.federal_registration"
                                        hide-details outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select no-data-text="Nenhuma informação disponível" dense
                                        :items="dataset.statesList" label="UF"
                                        v-model="dataList.filter.federal_registration_uf" item-value="name"
                                        item-text="name" outlined hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="filter-card-title">Filtros</v-card-title>
                    <v-form @submit.prevent="load()">
                        <v-card-text>
                            <v-row>
                                <v-col cols="auto" sm="3">
                                    <v-select style="padding-left: 4px;" dense :items="dataset.statesList" label="UF"
                                        v-model="dataList.filter.federal_registration_uf" item-value="name"
                                        item-text="name" outlined hide-details="auto"
                                        no-data-text="Nenhuma informação disponível" @change="load">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-divider class="mt-2"></v-divider>

                        <v-container>
                            <v-row class="mt-3">
                                <v-col cols="4" align-self="baseline">
                                    <v-text-field style="padding-left: 8px;" dense label="Procurar"
                                        v-model="dataList.filter.content" no-data-text="Nenhuma informação disponível"
                                        hide-details outlined clearable @click:clear="clearNameSearch">
                                    </v-text-field>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col v-if="hasFilters()" cols="auto" style="padding-right: 1px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnClearFilter" type="button" outlined color="primary"
                                                @click="clearFilters">
                                                Limpar</v-btn>
                                        </template>
                                        <span>Limpar filtros de busca selecionados</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="auto" style="padding-right: 16px;">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>

                    <v-row>
                        <v-col cols="12">
                            <v-card outlined class="pa-3">

                                <!-- Cabeçalho da moldura -->
                                <div class="d-flex align-center justify-space-between mb-2">
                                    <div class="font-weight-medium text-subtitle-1">
                                        🔍 Filtros Rápidos
                                    </div>
                                    <div class="caption grey--text text--darken-1">
                                        <strong>Selecionado:</strong>
                                        <span class="ml-1">{{ currentStatusLabel }}</span>
                                    </div>
                                </div>

                                <!-- Abas de filtro -->
                                <v-tabs v-model="selectedStatus" background-color="transparent" show-arrows
                                    slider-color="primary">
                                    <v-tab @click="setFilterStatus('')" ripple>
                                        <v-icon small left color="grey darken-2">mdi-format-list-bulleted</v-icon>
                                        <span class="tab-text">Todos</span>
                                    </v-tab>

                                    <v-tab @click="setFilterStatus(0)">
                                        <v-icon small left color="warning darken-3">mdi-timer-sand</v-icon>
                                        <span class="tab-text">Pendente</span>
                                    </v-tab>

                                    <v-tab @click="setFilterStatus(1)">
                                        <v-icon small left color="accent">mdi-check-circle-outline</v-icon>
                                        <span class="tab-text">Aprovado</span>
                                    </v-tab>

                                    <v-tab @click="setFilterStatus(2)">
                                        <v-icon small left color="error">mdi-close-circle-outline</v-icon>
                                        <span class="tab-text">Rejeitado</span>
                                    </v-tab>

                                    <v-tab @click="setFilterStatus(4)">
                                        <v-icon small left color="indigo">mdi-check-decagram-outline</v-icon>
                                        <span class="tab-text">Aguardando procuração</span>
                                    </v-tab>

                                    <v-tab @click="setFilterStatus(5)">
                                        <v-icon small left color="#9FA8DA">mdi-alert-outline</v-icon>
                                        <span class="tab-text">Atualização procurador</span>
                                    </v-tab>

                                    <v-tab @click="setFilterStatus(6)">
                                        <v-icon small left color="#9FA8DA">mdi-gavel</v-icon>
                                        <span class="tab-text">Inventariante</span>
                                    </v-tab>

                                </v-tabs>

                            </v-card>
                        </v-col>
                    </v-row>

                    <v-card-title class="table-card-title">Procuradores</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum procurador foi encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">
                            <template v-slot:[`item.name`]="{ item }">
                                <!-- <v-avatar :size="30">
                                    <img :src="'https://ui-avatars.com/api/?name=' + item.name" />
                                </v-avatar>
                                <span class="ml-4 list-item-title">{{ item.name }}</span><br /> -->

                                <div class="d-flex align-center">
                                    <v-tooltip bottom v-if="item.is_executor == 1">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" color="deep-purple" small class="mr-2">
                                                mdi-gavel
                                            </v-icon>
                                        </template>
                                        <span>
                                            Este procurador atua como <strong>Inventariante</strong>.<br>
                                        </span>
                                    </v-tooltip>
                                    <v-avatar :size="30">
                                        <img :src="'https://ui-avatars.com/api/?name=' + item.name" />
                                    </v-avatar>

                                    <div class="ml-4">
                                        <span class="list-item-title">{{ item.name }}</span><br />
                                    </div>
                                </div>
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip :color="item.status == 0 ? 'accent' : 'error'" label text-color="white" small>
                                    {{ item.status | enum(dataset.status, "id", "name") }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.account_verified_at`]="{ item }">
                                <v-chip
                                    :color="item.account_verified_at !== '0000-00-00 00:00:00' ? 'accent' : 'warning'"
                                    label text-color="white" small>
                                    {{ item.account_verified_at !== '0000-00-00 00:00:00' ? 'SIM' : 'NÃO' }}
                                </v-chip>
                            </template>

                            <!-- <template v-slot:[`item.pending`]="{ item }">
                                <v-chip :color="item.has_pending_items ? 'warning' : 'accent'" label text-color="white"
                                    small>
                                    {{ item.has_pending_items ? 'SIM' : 'NÃO' }}
                                </v-chip>
                            </template> -->

                            <template v-slot:[`item.pending`]="{ item }">
                                <v-chip v-if="!item.has_pending_items" color="accent" label text-color="white" small>
                                    NÃO
                                </v-chip>

                                <v-tooltip v-else bottom color="grey darken-4">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-chip v-bind="attrs" v-on="on" color="warning" label text-color="white" small>
                                            SIM
                                            <v-icon right x-small>mdi-alert-circle-outline</v-icon>
                                        </v-chip>
                                    </template>

                                    <div class="py-1">
                                        <div class="mb-2"
                                            style="border-bottom: 1px solid #777; font-weight: bold; font-size: 12px">
                                            PENDÊNCIA:
                                        </div>

                                        <template v-for="(value, key) in item.pending_items">
                                            <div v-if="value === true" :key="key" class="d-flex align-center mb-1">
                                                <v-icon color="orange lighten-2" x-small
                                                    class="mr-2">mdi-close-octagon</v-icon>
                                                <span class="white--text" style="font-size: 11px">
                                                    {{ dataset.pendingLabels[key] || key }}
                                                </span>
                                            </div>
                                        </template>
                                    </div>
                                </v-tooltip>
                            </template>

                            <template v-slot:[`item.federal_registration_uf`]="{ item }">
                                {{ item.federal_registration_uf }}
                            </template>

                            <template v-slot:[`item.federal_registration`]="{ item }">
                                {{ item.federal_registration }}
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon v-if="!$check(user, ['lawyers.update'])"
                                    :disabled="!$check(user, ['lawyers.find'])" @click="viewItem(item)" size="large"
                                    class="me-2">
                                    mdi-eye-outline
                                </v-icon>
                                <v-icon :disabled="(!$check(user, ['lawyers.update']))" @click="viewItem(item)"
                                    size="large" class="me-2">
                                    mdi-pencil-outline
                                </v-icon>
                                <v-icon :disabled="(!$check(user, ['lawyers.delete']))" @click="deleteItem(item)"
                                    size="large">
                                    mdi-delete-outline
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
                </v-col>
            </v-row>

            <v-dialog v-model="validationModal.open" max-width="820px" persistent>
                <v-card>
                    <v-card-title class="card-group-title">
                        Validar procuração
                        <v-spacer />
                        <v-btn icon @click="closeProcurationValidationModal">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="pt-5">
                        <v-alert dense outlined type="info">
                            Esta validação não altera o vínculo, não aprova a associação e não substitui o documento salvo.
                        </v-alert>

                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    dense
                                    outlined
                                    clearable
                                    return-object
                                    label="Procurador"
                                    no-data-text="Digite nome, CPF ou OAB para buscar"
                                    :items="validationModal.lawyers"
                                    :loading="validationModal.loadingLawyers"
                                    :item-text="formatLawyerOption"
                                    item-value="id"
                                    v-model="validationModal.lawyer"
                                    :search-input.sync="validationModal.lawyerSearch"
                                    @update:search-input="onValidationLawyerSearch"
                                    @change="onValidationLawyerSelected"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    dense
                                    outlined
                                    clearable
                                    return-object
                                    label="Credor pré-vinculado"
                                    no-data-text="Selecione um procurador para carregar os credores vinculados"
                                    :items="validationModal.creditors"
                                    :loading="validationModal.loadingCreditors"
                                    :item-text="formatCreditorOption"
                                    item-value="id"
                                    v-model="validationModal.association"
                                    :disabled="!validationModal.lawyer"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-file-input
                                    dense
                                    outlined
                                    show-size
                                    clearable
                                    accept="application/pdf"
                                    prepend-icon="mdi-file-pdf-box"
                                    label="Procuração assinada GOV.BR"
                                    hint="Envie o PDF assinado para validar se corresponde ao documento gerado"
                                    persistent-hint
                                    :rules="[$rules.fileSize(10)]"
                                    v-model="validationModal.file"
                                />
                            </v-col>
                        </v-row>

                        <v-alert
                            v-if="validationModal.result"
                            dense
                            outlined
                            type="success"
                            class="mt-2"
                        >
                            Procuração validada com sucesso.
                            <div class="mt-1">
                                Assinaturas encontradas: {{ validationModal.result.signatureCount || 0 }}
                            </div>
                        </v-alert>

                        <v-alert
                            v-if="validationModal.error"
                            dense
                            outlined
                            type="error"
                            class="mt-2"
                        >
                            <span v-html="formatProcurationValidationError(validationModal.error)"></span>
                        </v-alert>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn text color="grey" @click="closeProcurationValidationModal">Fechar</v-btn>
                        <v-btn
                            color="primary"
                            :loading="validationModal.validating"
                            :disabled="!canValidateProcuration"
                            @click="validateProcuration"
                        >
                            Validar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';
import status from "@/common/data/user-status.data";

import object from "@/common/util/object"
import statesList from "@/common/data/states-list.data";

Vue.use(VueLodash)

export default {
    name: "LawyerList",

        data: () => ({
            user: null,
            selectedStatus: '',
            currentStatusLabel: 'Todos',
            validationModal: {
                open: false,
                lawyer: null,
                lawyerSearch: '',
                lawyers: [],
                loadingLawyers: false,
                association: null,
                creditors: [],
                loadingCreditors: false,
                file: null,
                validating: false,
                result: null,
                error: '',
            },
            dataset: {
            statesList: [{ id: "", name: "Todos" }, ...statesList],
            status: status,
            data: {},
            pendingLabels: {
                account_not_verified: "Conta do procurador",
                pending_associations: "Associação com credore(s)"
            },
        },
        dataList: {
            filter: {
                content: "",
                federal_registration_uf: "",
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "E-mail", value: "email" },
                { text: "OAB", value: "federal_registration" },
                { text: "UF", value: "federal_registration_uf" },
                { text: "Status", value: "status" },
                { text: "Conta verificada", value: "account_verified_at" },
                { text: "Pendência", value: "pending" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
        }),

        created() {
            this.searchValidationLawyersDebounced = _.debounce(this.searchValidationLawyers, 400);
            this.load();
        },

        computed: {
            canValidateProcuration() {
                return Boolean(
                    this.validationModal.lawyer &&
                    this.validationModal.association &&
                    this.validationModal.file &&
                    !this.validationModal.validating
                );
            },
        },

        methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "");
        },

        clearFilters() {
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = "";
            });
            this.load();
        },

        clearNameSearch() {
            this.dataList.filter.content = "";
            this.load();
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

            reload: function () {
                this.load();
            },

            async load() {
                this.user = this.$root.user.data || this.$root.user;

            let search = Object.fromEntries(
                Object.entries(this.dataList.filter).filter(
                    ([key, value]) => value !== undefined && value !== "Todos" && value !== ""
                )
            );

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;

            try {
                const result = await axios.get('/api/admin/lawyers/list', { params: { page: this.dataList.options.page, limit: 10, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                })
            } finally {
                    this.dataList.loading = false;
                }
            },

            openProcurationValidationModal() {
                this.validationModal.open = true;
                this.validationModal.result = null;
                this.validationModal.error = '';

                if (!this.validationModal.lawyers.length) {
                    this.searchValidationLawyers('');
                }
            },

            closeProcurationValidationModal() {
                this.validationModal.open = false;
                this.validationModal.lawyer = null;
                this.validationModal.lawyerSearch = '';
                this.validationModal.association = null;
                this.validationModal.creditors = [];
                this.validationModal.file = null;
                this.validationModal.result = null;
                this.validationModal.error = '';
            },

            onValidationLawyerSearch(value) {
                if (this.validationModal.lawyer && value === this.formatLawyerOption(this.validationModal.lawyer)) {
                    return;
                }

                this.searchValidationLawyersDebounced(value || '');
            },

            async searchValidationLawyers(searchTerm = '') {
                const content = String(searchTerm || '').trim();

                if (content && content.length < 2) {
                    return;
                }

                this.validationModal.loadingLawyers = true;

                try {
                    const search = content ? JSON.stringify({ content }) : null;
                    const result = await axios.get('/api/admin/lawyers/list', {
                        params: {
                            page: 1,
                            limit: 10,
                            search,
                        },
                    });

                    this.validationModal.lawyers = result.data.content.data || [];
                } catch (error) {
                    this.$dialog.notify.error(this.$codes(error), {
                        position: 'top-right',
                        timeout: 5000
                    });
                } finally {
                    this.validationModal.loadingLawyers = false;
                }
            },

            async onValidationLawyerSelected(lawyer) {
                this.validationModal.association = null;
                this.validationModal.creditors = [];
                this.validationModal.result = null;
                this.validationModal.error = '';

                if (!lawyer || !lawyer.id) return;

                this.validationModal.loadingCreditors = true;

                try {
                    const result = await axios.get(`/api/admin/lawyers/associated-users/${lawyer.id}`, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    });

                    this.validationModal.creditors = (result.data.content.associations || [])
                        .filter(item => item.recordType !== 'draft');
                } catch (error) {
                    this.$dialog.notify.error(this.$codes(error), {
                        position: 'top-right',
                        timeout: 5000
                    });
                } finally {
                    this.validationModal.loadingCreditors = false;
                }
            },

            async validateProcuration() {
                if (!this.canValidateProcuration) return;

                const formData = new FormData();
                formData.append('signed_pdf', this.validationModal.file);

                this.validationModal.validating = true;
                this.validationModal.result = null;
                this.validationModal.error = '';

                try {
                    const result = await axios.post(
                        `/api/admin/lawyers/association-user-validate-template-pdf/${this.validationModal.association.id}`,
                        formData,
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                            },
                        }
                    );

                    this.validationModal.result = result.data.content || { signatureCount: 0 };
                } catch (error) {
                    this.validationModal.error = this.$codes(error);
                } finally {
                    this.validationModal.validating = false;
                }
            },

            formatLawyerOption(item) {
                if (!item) return '';

                const oab = item.is_executor ? 'Inventariante' : `OAB ${item.federal_registration || 'N/A'}-${item.federal_registration_uf || 'N/A'}`;
                return `${item.name || 'Sem nome'} | CPF ${this.formatRegistration(item.registration)} | ${oab}`;
            },

            formatCreditorOption(item) {
                if (!item || !item.user) return '';

                return `${item.user.name || 'Sem nome'} | ${this.formatRegistration(item.user.registration)} | ${this.getAssociationStatusText(item.status)}`;
            },

            getAssociationStatusText(status) {
                const labels = {
                    0: 'Pendente',
                    1: 'Aprovado',
                    2: 'Rejeitado',
                    3: 'Removido',
                    4: 'Aguardando procuração',
                    5: 'Atualização procurador',
                };

                return labels[Number(status)] || 'Status não informado';
            },

            formatRegistration(value) {
                if (!value) return 'N/A';

                const digits = String(value).replace(/\D/g, '');

                if (digits.length === 11) {
                    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
                }

                if (digits.length === 14) {
                    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
                }

                return value;
            },

            formatProcurationValidationError(message) {
                const normalizedMessage = this.normalizeProcurationValidationMessage(message);

                return `
                    <strong>Não foi possível validar a procuração enviada.</strong><br><br>
                    ${normalizedMessage}
                `;
            },

            normalizeProcurationValidationMessage(message) {
                const safeMessage = message || 'Erro desconhecido ao validar o PDF da procuração.';
                const lowerMessage = safeMessage.toLowerCase();

                if (lowerMessage.includes('referência não encontrada')) {
                    return 'Não localizamos no PDF o código interno da procuração gerada pela plataforma. Isso geralmente acontece quando o arquivo enviado não é a procuração baixada no sistema, foi escaneado/impresso, ou foi salvo novamente por outro editor antes da assinatura. Baixe novamente a procuração na plataforma, assine o PDF original pelo GOV.BR sem alterar o arquivo e envie exatamente o PDF assinado.';
                }

                if (lowerMessage.includes('informações do documento de procuração não encontradas')) {
                    return 'Não localizamos no PDF as informações internas de segurança da procuração gerada pela plataforma. O arquivo pode ter sido editado, convertido, impresso/escaneado ou pode não ser o documento gerado pelo sistema. Baixe novamente a procuração na plataforma, assine o PDF original pelo GOV.BR sem alterar o arquivo e envie exatamente o PDF assinado.';
                }

                if (lowerMessage.includes('documento de procuração não confere')) {
                    return 'O PDF enviado possui dados internos diferentes da procuração gerada pela plataforma. Isso indica que o arquivo não corresponde ao documento original ou foi alterado após a geração. Baixe novamente a procuração, assine o PDF original pelo GOV.BR e envie o arquivo assinado sem editar, renomear por conversores, compactar, imprimir ou escanear.';
                }

                if (lowerMessage.includes('assinatura digital não localizada')) {
                    return 'Não encontramos assinatura digital no PDF enviado. O arquivo precisa ser o PDF assinado digitalmente pelo GOV.BR, não apenas a procuração baixada, uma imagem, uma digitalização ou o comprovante/resumo da assinatura.';
                }

                if (lowerMessage.includes('assinatura não aceita')) {
                    return 'A assinatura digital encontrada não foi emitida pela plataforma GOV.BR. Para esta validação, o documento deve ser assinado exclusivamente pelo GOV.BR. Assine novamente a procuração original usando GOV.BR e envie o PDF assinado gerado ao final do processo.';
                }

                if (lowerMessage.includes('nenhum representante legal')) {
                    return 'Este credor é uma empresa, mas não há representante legal cadastrado/aprovado para validar a assinatura. Cadastre ou regularize o representante legal da empresa e depois envie novamente a procuração assinada por esse representante.';
                }

                if (lowerMessage.includes('representante cadastrado') || lowerMessage.includes('representante legal aprovado')) {
                    return 'O CPF do assinante digital não corresponde a nenhum representante legal cadastrado/aprovado para esta empresa. O PDF deve ser assinado pelo representante legal vinculado ao cadastro do credor. Verifique o representante cadastrado ou assine novamente com o CPF correto pelo GOV.BR.';
                }

                if (lowerMessage.includes('cpf do assinante')) {
                    return 'O CPF do assinante digital não corresponde ao CPF do credor selecionado. Confirme se a procuração pertence a este credor e se foi assinada no GOV.BR pelo próprio credor correto. Se necessário, gere uma nova procuração para o credor correto e assine novamente.';
                }

                return safeMessage;
            },


            viewItem(item) {
            window.open(`#/procuradores/${item.id}`);
            //this.$router.push(`procuradores/${item.id}`);
        },

        setFilterStatus(status) {
            const labels = {
                '': 'Todos',
                0: 'Pendente',
                1: 'Aprovado',
                2: 'Rejeitado',
                3: 'Aprovado Parcial',
                4: 'Aguardando Procuração',
                5: 'Atualização Procurador',
                6: 'Inventariante',
                7: 'Sem retorno',
                8: 'Contraproposta Enviada',
                9: 'Contraproposta Rejeitada',
                10: 'Contraproposta Aceita',
            }
            this.currentStatusLabel = labels[status] || 'Todos'
            this.selectedStatus = status
            this.dataList.filter.status = status;
            this.load()
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir procurador',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/admin/lawyers/delete/${item.id}`)

                this.$dialog.notify.info("Procurador excluído com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataList.loading = false;
            }
        },
    },
};
</script>
